export const dictionaryRoles = {
  // CADASTRO OPERADOR
  callCenterCadastroOperadorVisualizarCondicionado: {
    description: "Leitura",
    value: "callCenter-cadastro-operador-visualizarCondicionado",
    id: 1,
  },

  callCenterCadastroOperadorEditarCondicionado: {
    description: "Editar",
    value: "callCenter-cadastro-operador-editarCondicionado",
    id: 2,
  },

  callCenterCadastroOperadorTotal: {
    description: "Total",
    value: "callCenter-cadastro-operador-total",
    id: 3,
  },

  // CADASTRO PAUSA
  callCenterCadastroPausaVisualizar: {
    description: "Leitura",
    value: "callCenter-cadastro-pausa-visualizar",
    id: 4,
  },

  callCenterCadastroPausaEditar: {
    description: "Editar",
    value: "callCenter-cadastro-pausa-editar",
    id: 5,
  },

  callCenterCadastroPausaTotal: {
    description: "Total",
    value: "callCenter-cadastro-pausa-total",
    id: 6,
  },

  // CADASTRO FILA
  callCenterCadastroFilaVisualizarCondicionado: {
    description: "Leitura",
    value: "callCenter-cadastro-fila-visualizarCondicionado",
    id: 7,
  },

  callCenterCadastroFilaEditarCondicionado: {
    description: "Editar",
    value: "callCenter-cadastro-fila-editarCondicionado",
    id: 8,
  },

  callCenterCadastroFilaTotal: {
    description: "Total",
    value: "callCenter-cadastro-fila-total",
    id: 9,
  },

  // RELATORIO OPERADOR

  callCenterRelatorioOperadorVisualizarCondicionado: {
    description: "Acesso",
    value: "callCenter-relatorio-operador-visualizarCondicionado",
    id: 10,
  },

  callCenterRelatorioOperadorOuvirGravacao: {
    description: "Ouvir Gravações",
    value: "callCenter-relatorio-operador-ouvirGravacao",
    id: 11,
  },

  callCenterRelatorioOperadorHistorico: {
    description: "Histórico sem Gravações",
    value: "callCenter-relatorio-operador-historico",
    id: 12,
  },

  callCenterRelatorioOperadorOuvirGravacaoHistorico: {
    description: "Histórico com Gravações",
    value: "callCenter-relatorio-operador-ouvirGravacaoHistorico",
    id: 13,
  },

  callCenterRelatorioOperadorTotal: {
    description: "Total",
    value: "callCenter-relatorio-operador-total",
    id: 14,
  },

  // RELATORIO FILA

  callCenterRelatorioFilaVisualizarCondicionado: {
    description: "Acesso",
    value: "callCenter-relatorio-fila-visualizarCondicionado",
    id: 15,
  },

  callCenterRelatorioFilaOuvirGravacao: {
    description: "Ouvir Gravações",
    value: "callCenter-relatorio-fila-ouvirGravacao",
    id: 16,
  },

  callCenterRelatorioFilaHistorico: {
    description: "Histórico sem Gravações",
    value: "callCenter-relatorio-fila-historico",
    id: 17,
  },

  callCenterRelatorioFilaOuvirGravacaoHistorico: {
    description: "Histórico com Gravações",
    value: "callCenter-relatorio-fila-ouvirGravacaoHistorico",
    id: 18,
  },

  callCenterRelatorioFilaTotal: {
    description: "Total",
    value: "callCenter-relatorio-fila-total",
    id: 19,
  },

  // RELATORIO DISPONIBILIDADE

  callCenterRelatorioDisponibilidadeVisualizarCondicionado: {
    description: "Acesso",
    value: "callCenter-relatorio-disponibilidade-visualizarCondicionado",
    id: 20,
  },

  callCenterRelatorioDisponibilidadeTotal: {
    description: "Total",
    value: "callCenter-relatorio-disponibilidade-total",
    id: 21,
  },

  // OPERADORES

  callCenterOperador: {
    description: "Operador",
    value: "callCenter-operador",
    id: 22,
  },

  // MANUTENCAO

  callCenterManutencaoVisualizar: {
    description: "Acesso",
    value: "callCenter-manutencao-visualizar",
    id: 23,
  },

  // MONITOR

  callCenterMonitorVisualizar: {
    description: "Acesso",
    value: "callCenter-monitor-visualizar",
    id: 24,
  },

  callCenterMonitorPausaDespausa: {
    description: "Pausar/Despausar Operador",
    value: "callCenter-monitor-pausa-despausa",
    id: 25,
  },

  callCenterMonitorAdicionarOperadorRemoverOperador: {
    description: "Adicionar/Remover Operador",
    value: "callCenter-monitor-adicionarOperador-removerOperador",
    id: 26,
  },

  callCenterMonitorDeslogarOperador: {
    description: "Deslogar Operador",
    value: "callCenter-monitor-deslogarOperador",
    id: 27,
  },

  callCenterMonitorOuvirOperador: {
    description: "Ouvir Ligações",
    value: "callCenter-monitor-ouvirOperador",
    id: 28,
  },

  callCenterMonitorTotal: {
    description: "Total",
    value: "callCenter-monitor-total",
    id: 29,
  },

  // CONTROLE DE ACESSO
  // perfil

  controleAcessoPerfilVisualizar: {
    description: "Leitura",
    value: "controleAcesso-perfil-visualizar",
    id: 30,
  },

  controleAcessoPerfilEditar: {
    description: "Editar",
    value: "controleAcesso-perfil-editar",
    id: 31,
  },

  controleAcessoPerfilTotal: {
    description: "Total",
    value: "controleAcesso-perfil-total",
    id: 32,
  },

  // USUARIOS

  controleAcessoUsuariosVisualizarCondicionado: {
    description: "Leitura",
    value: "controleAcesso-usuarios-visualizarCondicionado",
    id: 33,
  },

  controleAcessoUsuariosEditarCondicionado: {
    description: "Editar",
    value: "controleAcesso-usuarios-editarCondicionado",
    id: 34,
  },

  controleAcessoUsuariosTotal: {
    description: "Total",
    value: "controleAcesso-usuarios-total",
    id: 35,
  },

  // Auditoria

  controleAcessoAuditoriaVisualizarCondicionado: {
    description: "Visualizar",
    value: "controleAcesso-auditoria-visualizarCondicionado",
    id: 36,
  },

  controleAcessoAuditoriaTotal: {
    description: "Total",
    value: "controleAcesso-auditoria-total",
    id: 37,
  },

  //Token

  controleAcessoTokenVisualizar: {
    description: "Visualizar",
    value: "controleAcesso-token-visualizar",
    id: 38,
  },

  // PESQUISA DE SATISFACAO
  //CADASTRO

  pesquisaCadastroVisualizarCondicionado: {
    description: "Leitura",
    value: "pesquisa-cadastro-visualizarCondicionado",
    id: 39,
  },

  pesquisaCadastroEditarCondicionado: {
    description: "Editar",
    value: "pesquisa-cadastro-editarCondicionado",
    id: 40,
  },

  pesquisaCadastroTotal: {
    description: "Total",
    value: "pesquisa-cadastro-total",
    id: 41,
  },

  //RELATORIO

  pesquisaRelatorioVisualizarCondicionado: {
    description: "Acesso",
    value: "pesquisa-relatorio-visualizarCondicionado",
    id: 42,
  },

  pesquisaRelatorioOuvirGravacao: {
    description: "Ouvir áudio da pesquisa",
    value: "pesquisa-relatorio-ouvirGravacao",
    id: 43,
  },

  pesquisaRelatorioHistorico: {
    description: "Histórico sem Gravações",
    value: "pesquisa-relatorio-historico",
    id: 44,
  },

  pesquisaRelatorioOuvirGravacaoHistorico: {
    description: "Histórico com Gravações",
    value: "pesquisa-relatorio-ouvirGravacaoHistorico",
    id: 45,
  },

  pesquisaRelatorioTotal: {
    description: "Total",
    value: "pesquisa-relatorio-total",
    id: 46,
  },

  // Relatorio PABX
  //Chamadas

  relatorioChamadasVisualizarCondicionado: {
    description: "Acesso",
    value: "relatorio-chamadas-visualizarCondicionado",
    id: 47,
  },

  relatorioChamadasOuvirGravacao: {
    description: "Ouvir Gravações",
    value: "relatorio-chamadas-ouvirGravacao",
    id: 48,
  },

  relatorioChamadasTotal: {
    description: "Total",
    value: "relatorio-chamadas-total",
    id: 49,
  },

  //conferencia

  relatorioConferenciaVisualizarCondicionado: {
    description: "Acesso",
    value: "relatorio-conferencia-visualizarCondicionado",
    id: 50,
  },

  relatorioConferenciaOuvirGravacao: {
    description: "Ouvir Gravações",
    value: "relatorio-conferencia-ouvirGravacao",
    id: 51,
  },

  relatorioConferenciaTotal: {
    description: "Total",
    value: "relatorio-conferencia-total",
    id: 52,
  },

  // MODULO Monitor RAMAL

  monitorCondicinado: {
    description: "Acesso",
    value: "monitor-condicinado",
    id: 53,
  },

  monitorOuvirRamal: {
    description: "Ouvir Ligações",
    value: "monitor-ouvirRamal",
    id: 54,
  },

  monitorTotal: {
    description: "Total",
    value: "monitor-total",
    id: 55,
  },

  // MODULO PABX

  pabxHabilitado: {
    description: "Acesso",
    value: "pabx-habilitado",
    id: 56,
  },

  adminGeralSistema: {
    description: "Administrador do Sistema",
    value: "adminGeral-sistema",
    id: 57,
  },

  // DEPARTAMENTOS

  callCenterCadastroDepartamentosVisualizarCondicionado: {
    description: "Leitura",
    value: "callCenter-cadastro-departamentos-visualizarCondicionado",
    id: 58,
  },

  callCenterCadastroDepartamentosEditarCondicionado: {
    description: "Editar",
    value: "callCenter-cadastro-departamentos-editarCondicionado",
    id: 59,
  },

  callCenterCadastroDepartamentosTotal: {
    description: "Total",
    value: "callCenter-cadastro-departamentos-total",
    id: 60,
  },

  //Configuração monitor operador
  
  callCenterConfiguracaoMonitorOperador: {
    description: "Acesso",
    value: "callCenter-configuracaomonitor-visualizar",
    id: 61,
  },

  // Monitor Operador

  callCenterMonitorOperadorVisualizarCondicionado: {
    description: "Visualizar",
    value: "callCenter-monitor-operador-visualizarCondicionado",
    id: 62,
  },

  callCenterMonitorOperadorTotal: {
    description: "Total",
    value: "callCenter-monitor-operador-total",
    id: 63,
  },
  callCenterMonitorOperadorPausaDespausa: {
    description: "Pausa e Despausa",
    value: "callCenter-monitor-operador-pausa-despausa",
    id: 64,
  },
  callCenterMonitorOperadorRemoverFila: {
    description: "Remover Fila",
    value: "callCenter-monitor-operador-remover-fila",
    id: 65,
  },
  callCenterMonitorOperadorDeslogarOperador: {
    description: "Deslogar Operador",
    value: "callCenter-monitor-operador-deslogar-operador",
    id: 66,
  },
  callCenterMonitorOperadorOuvirOperador: {
    description: "Ouvir Operador",
    value: "callCenter-monitor-operador-ouvir-operador",
    id: 67,
  },

  // Relatorio PABX
  relatorioPABXChamadasProtocolo: {
    description: "Acesso",
    value: "relatorio-chamadas-PABX-protocolo",
    id: 68,
  },
};
